<template>
  <div>
    <a-drawer width="400" @close="onClose" :visible="visible" :closable="false">
      <a-button shape="circle" icon="close" @click="onClose"></a-button>
      <userinfo @refresh="() => $emit('refresh')" v-if="currentFansId && currentRobotId" 
        :robotid="currentRobotId" :fansid="currentFansId"
        ></userinfo>
    </a-drawer>
  </div>
</template>

<script>
import Userinfo from '@/views/fans/detail/userinfo'
export default {
  components: {
    Userinfo
  },
  data() {
    return {
      visible: false,
      currentRobotId: null,
      currentFansId: null
    }
  },
  created() {},
  methods: {
    show(robotid, fansid) {
      this.currentRobotId = robotid
      this.currentFansId = fansid
      this.visible = true
    },
    onClose() {
      this.currentRobotId = null
      this.currentFansId = null
      this.visible = false
      this.$emit('refresh')
    }
  }
}
</script>

<style lang="less" scoped>
</style>
